import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-moving-tips-page',
	templateUrl: './moving-tips-page.component.html',
	styleUrls: ['./moving-tips-page.component.sass']
})
export class MovingTipsPageComponent implements OnInit {

	constructor(private metaService: MetaService) { }

	ngOnInit() {
		this.metaService.apply('moving-tips')
	}

}
